import { QuizSettings } from "@/modes/quiz/QuizSettings";
import { QuizStudent } from "@/modes/quiz/QuizStudent";
import { QuizBoard } from "@/modes/quiz/QuizBoard";
import { QuizTeacher } from "@/modes/quiz/QuizTeacher";

const quiz = {
  key: "quiz",
  label: "Klasik Hızlı Quiz",
  SettingsForm: QuizSettings,
  StudentView: QuizStudent,
  BoardView: QuizBoard,
  TeacherView: QuizTeacher,
};

export default quiz;
